module.exports = __webpack_public_path__ + "media/images/athletes/255-de92872812b1dc5bd4c83ad150b23a2d.png";